import {
    GET_ALL_CATEGORIES_PENDING,
    GET_ALL_CATEGORIES_FULFILLED,
    GET_ALL_CATEGORIES_FAILED,
    GET_ALL_TYPES_PENDING,
    GET_ALL_TYPES_FULFILLED,
    GET_ALL_TYPES_REJECTED,
    GET_TYPE_PENDING,
    GET_TYPE_FULFILLED,
    GET_TYPE_REJECTED,
    GET_CATEGORY_PENDING,
    GET_CATEGORY_FULFILLED,
    GET_CATEGORY_REJECTED,
    GET_TYPES_PENDING,
    GET_TYPES_FULFILLED,
    GET_TYPES_REJECTED
} from '../actions/CategoryActions';

// INITIALIZE STATE
const initialState = {
    allProductCategories: [],
    allProductTypes: [],
    productTypes: [],
    productType: {},
    productCategory: {},
    fetchingAllProductCategories: false,
    fetchedAllProductCategories: false,
    failedAllProductCategories: false,
    fetchingAllProductTypes: false,
    fetchedAllProductTypes: false,
    failedAllProductTypes: false,
    fetchingProductCategory: false,
    fetchedProductCategory: false,
    failedProductCategory: false,
    fetchingProductType: false,
    fetchedProductType: false,
    failedProductType: false,
    fetchingProductTypes: false,
    fetchedProductTypes: false,
    failedProductTypes: false,
};

export const CategoryReducer = (state = initialState, action) => {
    switch(action.type) {
        case GET_ALL_CATEGORIES_PENDING:
            return {
                ...state,
                fetchingAllProductCategories: true,
                fetchedAllProductCategories: false,
                failedAllProductCategories: false
            };
        case GET_ALL_CATEGORIES_FULFILLED:
            return {
                ...state,
                allProductCategories: action.payload,
                fetchingAllProductCategories: false,
                fetchedAllProductCategories: true,
                failedAllProductCategories: false,
            };
        case GET_ALL_CATEGORIES_FAILED:
            return {
                ...state,
                fetchingAllProductCategories: false,
                fetchedAllProductCategories: false,
                failedAllProductCategories: true,
            };
        case GET_ALL_TYPES_PENDING:
            return {
                ...state,
                fetchingAllProductTypes: true,
                fetchedAllProductTypes: false,
                failedAllProductTypes: false
            };
        case GET_ALL_TYPES_FULFILLED:
            return {
                ...state,
                allProductTypes: action.payload,
                fetchingAllProductTypes: false,
                fetchedAllProductTypes: true,
                failedAllProductTypes: false
            };
        case GET_ALL_TYPES_REJECTED:
            return {
                ...state,
                fetchingAllProductTypes: false,
                fetchedAllProductTypes: false,
                failedAllProductTypes: true
            };
        case GET_TYPE_PENDING:
            return {
                ...state,
                fetchingProductType: true,
                fetchedProductType: false,
                failedProductType: false
            };
        case GET_TYPE_FULFILLED:
            return {
                ...state,
                productType: action.payload,
                fetchingProductType: false,
                fetchedProductType: true,
                failedProductType: false
            };
        case GET_TYPE_REJECTED:
            return {
                ...state,
                fetchingProductType: false,
                fetchedProductType: false,
                failedProductType: true
            };
        case GET_CATEGORY_PENDING:
            return {
                ...state,
                fetchingProductCategory: true,
                fetchedProductCategory: false,
                failedProductCategory: false,
            };
        case GET_CATEGORY_FULFILLED:
            return {
                ...state,
                productCategory: action.payload,
                fetchingProductCategory: false,
                fetchedProductCategory: true,
                failedProductCategory: false,
            };
        case GET_CATEGORY_REJECTED:
            return {
                ...state,
                fetchingProductCategory: false,
                fetchedProductCategory: false,
                failedProductCategory: true,
            };
        case GET_TYPES_PENDING:
            return {
                ...state,
                fetchingProductTypes: true,
                fetchedProductTypes: false,
                failedProductTypes: false
            };
        case GET_TYPES_FULFILLED:
            return {
                ...state,
                productTypes: action.payload,
                fetchingProductTypes: false,
                fetchedProductTypes: true,
                failedProductTypes: false
            };
        case GET_TYPES_REJECTED:
            return {
                ...state,
                fetchingProductTypes: false,
                fetchedProductTypes: false,
                failedProductTypes: true
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/components/state/reducers/CategoryReducer.js